import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import { Link, useNavigate, useLocation } from "react-router-dom";
import wtechinLogo from "../../images/wtechin.png";
import Button from "@mui/material/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import Chip from "@mui/material/Chip";
import Avatar from "@mui/material/Avatar";
import { useFetchMeQuery, useLogoutMutation } from "../../store";
import { deepPurple } from "@mui/material/colors";
import { AppBar } from "./components/AppBar";
import { googleLogout } from "@react-oauth/google";
import { LogoContainer } from "./components/LogoContainer";
import Loading from "../../components/shared/Loading";
import { PERSONEL } from "../../roles";
// import Box from "@mui/material/Box";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: user, isLoading: userLoading } = useFetchMeQuery();
  const [logoutMutate, { isLoading }] = useLogoutMutation();

  const logout = () => {
    localStorage.removeItem("access-token");
    googleLogout();
    logoutMutate();
  };

  const handleProfileClick = () => {
    if (user?.roleId !== PERSONEL) {
      navigate("/profil");
    } else {
      navigate(`/personel-detail/0`);
    }
  };

  const BRAND_RED = "#8B1A1A";

  const navItems = [
    { label: "İzinler", path: "/izinler" },
    { label: "Personel Listesi", path: "/personel-list", roles: ["admin", "manager"] },
    { label: "Uygulama Yönetimi", path: "/application-management", roles: ["admin", "manager"] },
    { label: "Yeni Personel", path: "/new-personel", roles: ["admin", "manager"] },
  ];

  if (userLoading) return <Loading isLoading={userLoading} />;

  return (
    <AppBar color="inherit" position="absolute" sx={{ displayPrint: "none" }}>
      <Toolbar sx={{ backgroundColor: "inherit", mx: { xs: -0.75, sm: -1 } }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            flexWrap: "wrap",
            width: "100%",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Link to="/" style={{ textDecoration: "none" }}>
              <Stack direction="row" alignItems="center">
                <LogoContainer>
                  <img
                    src={wtechinLogo}
                    alt="Logo"
                    width="150px"
                    style={{ cursor: "pointer" }}
                    onClick={() => navigate("/")}
                  />
                </LogoContainer>
              </Stack>
            </Link>
            {user && (
              <Stack direction="row" spacing={1} sx={{ ml: 2 }}>
                {navItems.map((item) => {
                  const isActive = location.pathname.startsWith(item.path);
                  const isManagerView = user.roleId !== PERSONEL;

                  if (item.roles && !isManagerView) return null;

                  return (
                    <Button
                      key={item.path}
                      component={Link}
                      to={item.path}
                      variant="text"
                      sx={{
                        color: isActive ? BRAND_RED : "#333",
                        fontWeight: isActive ? 700 : 500,
                        position: "relative",
                        px: 2,
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: BRAND_RED,
                        },
                        "&::after": {
                          content: '""',
                          position: "absolute",
                          bottom: 0,
                          left: "15%",
                          width: isActive ? "70%" : 0,
                          height: "3px",
                          backgroundColor: BRAND_RED,
                          transition: "width 0.2s ease-in-out",
                          borderRadius: "4px 4px 0 0",
                        },
                      }}
                    >
                      {item.label}
                    </Button>
                  );
                })}
              </Stack>
            )}
          </Stack>
          <Stack
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{ marginLeft: "auto" }}
          >
            {user && (
              <>
                <Chip
                  variant="outlined"
                  onClick={handleProfileClick}
                  avatar={
                    <Avatar
                      sx={{ bgcolor: deepPurple[500] }}
                      style={{ color: "white" }}
                    >
                      {`${user?.firstName.charAt(0)}${user?.lastName.charAt(0)}`}
                    </Avatar>
                  }
                  label={`${user?.firstName} ${user?.lastName}`}
                  sx={{
                    fontWeight: 600,
                    borderColor: BRAND_RED,
                    color: BRAND_RED,
                    "&:hover": { bgcolor: "rgba(139, 26, 26, 0.04)" },
                  }}
                />
                <Button
                  color="secondary"
                  startIcon={<LogoutIcon />}
                  variant="outlined"
                  onClick={logout}
                  disabled={isLoading}
                  sx={{
                    fontWeight: 600,
                    borderColor: BRAND_RED,
                    color: BRAND_RED,
                    "&:hover": {
                      borderColor: BRAND_RED,
                      bgcolor: "rgba(139, 26, 26, 0.04)",
                    },
                  }}
                >
                  Çıkış
                </Button>
              </>
            )}
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default Header;

